module.exports = __webpack_public_path__ + "img/perrito.d4d0e08c.png";